<template>
    <header class="header">
        <section class="contenedorInformacion">
            <img class="imagenLogo" src="../assets/NOLA-LOGO.png" @click="Dash" alt="" />
            <div class="infoContainer">
                <router-link to="/Perfil">
                    <button class="burgerMenu mostrar-movil">
                        <img src="../assets/svg/icono-usuario.svg" alt="" />
                    </button>
                </router-link>
                <div class="infoUsuario ocultar-movil">
                    <div class="nombreUsuario">{{ nombreCompletoUsuario }}</div>
                    <div class="locacionSistema">{{ rolUsuario }}</div>
                </div>
                <router-link to="/Perfil">
                    <div class="contenedorIconoUsuario ocultar-movil">
                        <img class="imagenUsuario" src="../assets/svg/icono-usuario.svg" alt="" />
                        <span v-if="numeroNotificaciones && numeroNotificaciones > 0" class="badge-notificacion"
                            :class="{ parpadea: parpadear }">
                            {{ numeroNotificaciones }}
                        </span>
                    </div>
                </router-link>
            </div>
        </section>
    </header>
</template>

<script>
export default {
    data() {
        return {
            nombreUsuario: '',
            rolUsuario: '',
            nombreCompletoUsuario: '',
            numeroNotificaciones: 0,
            parpadear: false
        };
    },
    mounted() {
        this.cargarUsuario();
        this.actualizarNotificaciones();
        window.addEventListener('storage', this.actualizarNotificaciones);
    },
    beforeUnmount() {
        window.removeEventListener('storage', this.actualizarNotificaciones);
    },
    methods: {
        Dash() {
            this.$router.push('./DashBoard');
        },
        formatearRolUsuario(rol) {
            const mapaRoles = {
                ROLE_ADMIN: 'ADMINISTRADOR',
                ROLE_KIOSKO: 'KIOSKO',
                ROLE_USER: 'USUARIO',
                ROLE_JEFE: 'JEFE',
                ROLE_DESARROLLADOR: 'DESARROLLADOR',
                ROLE_TESTER: 'TESTER',
                ROLE_RESIDENTE: 'RESIDENTE'
            };
            return mapaRoles[rol] || rol.replace('ROLE_', '').toUpperCase();
        },
        cargarUsuario() {
            let nombre = localStorage.getItem('nombreUsuario') || '';

            const partesInvalidas = [
                'no apellido paterno',
                'no apellido materno',
                'no apellido',
                'null',
                'undefined'
            ];

            partesInvalidas.forEach((parte) => {
                const regex = new RegExp(parte, 'i');
                nombre = nombre.replace(regex, '').trim();
            });

            this.nombreCompletoUsuario = nombre.replace(/\s\s+/g, ' ');

            const rolRaw = localStorage.getItem('rolUsuario') || 'ROL NO DISPONIBLE';
            this.rolUsuario = this.formatearRolUsuario(rolRaw);
        },
        actualizarNotificaciones() {
            const notis = JSON.parse(localStorage.getItem('notificaciones')) || [];
            const cantidadAnterior = this.numeroNotificaciones;
            this.numeroNotificaciones = notis.length;

            // Si aumentó el número de notificaciones, activa parpadeo
            if (this.numeroNotificaciones > cantidadAnterior) {
                this.parpadear = true;
                setTimeout(() => {
                    this.parpadear = false;
                }, 3000);
            }
        }
    }
};
</script>

<style scoped>
.header {
    display: block;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1030;
    height: 70px;
    background-color: #000000;
    box-shadow: 0px 3px 6px #00000029;
}

.contenedorInformacion {
    user-select: none;
    height: 85px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 35px;
    background-color: #6E44DA;
    transition: padding 0.2s;
}

.infoContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.infoUsuario {
    display: flex;
    flex-direction: column;
}

.nombreUsuario {
    font-size: 17px;
    text-align: center;
    margin-right: 20px;
    color: black;
    min-height: 18px;
    font-weight: 600;
}

.locacionSistema {
    font-size: 14px;
    margin-right: 20px;
    color: black;
    min-height: 18px;
    text-align: center;
}

.contenedorIconoUsuario {
    position: relative;
    width: 48px;
    height: 48px;
    background-color: #ffffff;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid black;
}

.imagenUsuario {
    width: 22px;
    height: 27px;
}

.imagenLogo {
    width: auto;
    height: 45px;
    cursor: pointer;
    transition: all 0.3s;
}

.imagenLogo:hover {
    opacity: 0.8;
    transform: scale(1.02);
}

.burgerMenu {
    border-radius: 100%;
    border: 0;
    width: 50px;
    height: 50px;
    cursor: pointer;
    justify-content: center;
    align-items: center;
}

.burgerMenu:hover {
    background-color: #202020;
}

.burgerMenu:active {
    background-color: #000000;
    transform: scale(0.95);
}

.ocultar-movil {
    display: flex;
}

.mostrar-movil {
    display: none;
}

@media (max-width: 810px) {
    .imagenLogo {
        height: 45px;
    }

    .contenedorInformacion {
        padding: 0 20px;
    }

    .ocultar-movil {
        display: none;
    }

    .mostrar-movil {
        display: flex;
    }
}

.badge-notificacion {
    position: absolute;
    top: -6px;
    right: -12px;
    background-color: #ffffff;
    color: #691c32;
    border-radius: 999px;
    padding: 2px 6px;
    font-size: 11px;
    font-weight: bold;
    min-width: 12px;
    height: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1.5px solid black;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
    z-index: 10;
    line-height: 1;
    white-space: nowrap;
}

/* Parpadeo para badge */
.parpadea {
    animation: parpadeo 1s infinite;
    box-shadow: 0 0 6px 2px #ff0000a0;
}

@keyframes parpadeo {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.4;
    }
}

@media (max-width: 810px) {
    .imagenLogo {
        height: 45px;
    }

    .contenedorInformacion {
        padding: 0 20px;
    }

    .ocultar-movil {
        display: none;
    }

    .mostrar-movil {
        display: flex;
    }
}

.badge-notificacion:empty {
    display: none;
}
</style>